import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import logoIzquierdo from '@/assets/logo_durango.png'
import logoDerecho from '@/assets/logo_salud.jpg'

function getBase64FromImage(imgUrl) {
  return new Promise((resolve) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      resolve(canvas.toDataURL('image/png'))
    }
    img.src = imgUrl
  })
}

function formatearFecha(fecha) {
  return new Intl.DateTimeFormat('es-MX', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }).format(new Date(fecha))
}

function formatMayusculas(palabras) {
  return palabras.toUpperCase()
}

function formatearFechaHora(fecha) {
  return new Intl.DateTimeFormat('es-MX', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(fecha))
}

function campo(doc, label, value, x, y, width = 70, minHeight = 10) {
  const text = value || ''
  const textLines = doc.splitTextToSize(text, width - 4)
  const boxHeight = Math.max(minHeight, textLines.length * 3.4 + 2)

  const pageHeight = doc.internal.pageSize.height
  const marginBottom = 25

  if (y + boxHeight + marginBottom > pageHeight) {
    doc.addPage()
    y = 20
  }

  // Label
  doc.setFontSize(7)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0, 0, 0)
  doc.text(label, x, y)

  // Texto
  doc.setFontSize(8)
  doc.setTextColor(78, 78, 78)
  doc.setFont('helvetica', 'normal')


  // Caja gris
  doc.setFillColor(245, 245, 245)
  doc.rect(x, y + 1, width, boxHeight, 'F')

  // Texto
  doc.text(textLines, x + 2, y + 5)
  doc.setDrawColor(208, 208, 208)
  doc.setLineWidth(0.3)
  doc.line(x, y + 1 + boxHeight, x + width, y + 1 + boxHeight)

  return y + boxHeight + 6
}


function tituloSeccion(doc, texto, y) {
  doc.setFontSize(10)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0)
  doc.text(texto.toUpperCase(), 15, y)

  doc.setDrawColor(7, 88, 144)
  doc.setLineWidth(0.4)
  doc.line(15, y + 2, 200, y + 2)

  return y + 8
}

async function generarNotaMedica(paciente, nota) {
  const doc = new jsPDF('p', 'mm', 'letter')
  const pageWidth = doc.internal.pageSize.getWidth()


  const logo1 = await getBase64FromImage(logoIzquierdo)
  const logo2 = await getBase64FromImage(logoDerecho)

  doc.addImage(logo1, 'PNG', 14, 5, 45, 30)
  doc.addImage(logo2, 'PNG', pageWidth - 60, 5, 45, 30)

  doc.setFontSize(11)
  doc.setFont('helvetica', 'bold')
  doc.text('SERVICIOS DE SALUD DEL ESTADO DE DURANGO', pageWidth / 2, 25, { align: 'center' })
  doc.setFontSize(12)
  doc.text('NOTA MÉDICA', pageWidth / 2, 30, { align: 'center' })

//  // FECHA DE ATENCION
//  doc.setTextColor(0)
//  doc.setFont('helvetica', 'bold')
//  doc.setFontSize(9)
//  doc.text('Fecha y hora de atención:' , pageWidth / 2, 20, { align: 'center' })
//  doc.setFont('helvetica', 'normal')
//  doc.text( formatearFecha(nota.fecha), pageWidth / 2, 24, { align: 'center' })
//  doc.setFont('helvetica', 'bold')
//  doc.text('Fecha y hora de generación:'  ,pageWidth / 2, 28, { align: 'center' })
//  doc.setFont('helvetica', 'normal')
//  doc.text(formatearFechaHora(new Date),pageWidth / 2, 32, { align: 'center' })


  let y = 45
  y = tituloSeccion(doc, 'DATOS GENERALES', y)
  campo(doc, 'No. Expediente:', nota.numeroExpediente, 85, y, 55, 5)
  y = campo(doc, 'Fecha y hora:', formatearFecha(nota.fecha.slice(0, -1)), 145, y, 55, 5)
  y = campo(doc, 'Nombre del paciente:', paciente.nombres + ' ' + paciente.apellidoPaterno + ' ' + paciente.apellidoMaterno, 15, y, 185, 5)
  campo(doc, 'Edad:', nota.edad, 15, y, 55, 5)
  campo(doc, 'Sexo:', nota.sexo, 75, y, 65, 5)
  y = campo(doc, 'Servicio:', nota.servicio, 145, y, 55, 5)


  y = tituloSeccion(doc, 'SIGNOS VITALES', y + 3)

  campo(doc, 'Peso:', nota.peso + ' KG', 15, y, 55, 5)
  campo(doc, 'Talla:', nota.talla + ' CM', 75, y, 65, 5)
  y = campo(doc, 'IMC:', nota.imc, 145, y, 55, 5)

  campo(doc, 'Tensión Arterial:', nota.tensionArterial, 15, y, 55, 5)
  y = campo(doc, 'Frecuencia Cardiaca:', nota.frecuenciaCardiaca, 75, y, 65, 5)

  campo(doc, 'Temperatura:', nota.temperatura, 15, y, 55, 6)
  y = campo(doc, 'Frecuencia Respiratoria:', nota.frecuenciaRespiratoria, 75, y, 65, 5)

  campo(doc, 'Cintura:', nota.cintura, 15, y, 55, 5)
  campo(doc, 'Cadera:', nota.cadera, 75, y, 65, 5)
  y = campo(doc, 'ICC:', nota.icc, 145, y, 55, 5)

  y = campo(doc, 'Antecedentes heredofamiliares:', nota.antecedentesHeredofamiliares, 15, y, 185, 5)
  y = campo(doc, 'Antecedentes personales no patologicos:', nota.antecedentesPersonalesNoPatologicos, 15, y, 185, 5)
  y = campo(doc, 'Antecedentes personales patologicos:', nota.antecedentesPersonalesPatologicos, 15, y, 185, 5)
  y = campo(doc, 'Antecedentes ginecoobestetrico:', nota.antecedentesGinecoobestetrico, 15, y, 185, 5)
  y = campo(doc, 'Padecimiento actual:', nota.padecimientoActual, 15, y, 185, 5)

  y = campo(doc, 'Exploración Física:', nota.exploracionFisica, 15, y, 185, 5)
  y = campo(doc, 'Plan de acción:', nota.planDeAcción, 15, y, 185, 5)
  y = campo(doc, 'Plan basado en guías practivas clínicas:', nota.planBasadoEnGuíasPractivasClínicas, 15, y, 185, 5)
  y = campo(doc, 'Pronostico:', nota.pronostico, 15, y, 185, 5)
  y = campo(doc, 'Diagnóstico de la Consulta:', nota.diagnósticoDeLaConsulta, 15, y, 185, 5)
  doc.addPage()
 y = 20
  y = tituloSeccion(doc, 'FIRMA DEL MÉDICO', y + 3)

  y = campo(doc, 'Nombre Completo:', nota.nombreMedico + ' ' + nota.apellidoPaterno+' '+ nota.apellidoMaterno, 15, y, 185, 5)
  y = campo(doc, 'Cédula Profesional:', nota.cedula, 15, y, 185, 5)
  y = campo(doc, 'Universidad de Origen:', nota.universidad, 15, y, 185, 5)
  y = campo(doc, 'Firma digitalizada:', nota.firmaMedico, 15, y, 185, 5)

  const lineaY = y 
  doc.setFontSize(10)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0)

  doc.line(pageWidth / 2 - 30, lineaY + 25, pageWidth / 2 + 30, lineaY + 25)
  doc.text(formatMayusculas( nota.nombreMedico + ' ' + nota.apellidoPaterno+' '+ nota.apellidoMaterno), pageWidth / 2, lineaY + 30, { align: 'center' })
  doc.text('NOMBRE Y FIRMA DEL MÉDICO', pageWidth / 2, lineaY + 35, { align: 'center' })


  // if (y + 40 > doc.internal.pageSize.height) {
  //   doc.addPage()
  //   y = 20
  // }

  // doc.save('Exp_' + nota.numeroExpediente+  '_NotaMedica_' + paciente.nombres + '_' + paciente.apellidoPaterno + '_' + paciente.apellidoMaterno + '.pdf')
  const base64 = doc.output('datauristring')
    return base64
}
export { generarNotaMedica }